/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    WorkbookTaskItemDto,
    WorkbookTaskItemDtoFromJSON,
    WorkbookTaskItemDtoFromJSONTyped,
    WorkbookTaskItemDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface CreateWorkbookTaskCommand
 */
export interface CreateWorkbookTaskCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateWorkbookTaskCommand
     */
    reasonId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkbookTaskCommand
     */
    statusId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkbookTaskCommand
     */
    taskId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkbookTaskCommand
     */
    workbookId: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateWorkbookTaskCommand
     */
    statechangedDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkbookTaskCommand
     */
    statechangedBy?: string | null;
    /**
     * 
     * @type {Array<WorkbookTaskItemDto>}
     * @memberof CreateWorkbookTaskCommand
     */
    items?: Array<WorkbookTaskItemDto> | null;
}

export function CreateWorkbookTaskCommandFromJSON(json: any): CreateWorkbookTaskCommand {
    return CreateWorkbookTaskCommandFromJSONTyped(json, false);
}

export function CreateWorkbookTaskCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateWorkbookTaskCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reasonId': !exists(json, 'reasonId') ? undefined : json['reasonId'],
        'statusId': !exists(json, 'statusId') ? undefined : json['statusId'],
        'taskId': json['taskId'],
        'workbookId': json['workbookId'],
        'statechangedDate': !exists(json, 'statechangedDate') ? undefined : (json['statechangedDate'] === null ? null : new Date(json['statechangedDate'])),
        'statechangedBy': !exists(json, 'statechangedBy') ? undefined : json['statechangedBy'],
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(WorkbookTaskItemDtoFromJSON)),
    };
}

export function CreateWorkbookTaskCommandToJSON(value?: CreateWorkbookTaskCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'reasonId': value.reasonId,
        'statusId': value.statusId,
        'taskId': value.taskId,
        'workbookId': value.workbookId,
        'statechangedDate': value.statechangedDate === undefined ? undefined : (value.statechangedDate === null ? null : value.statechangedDate.toISOString()),
        'statechangedBy': value.statechangedBy,
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(WorkbookTaskItemDtoToJSON)),
    };
}


